import search from './Search'
import {Search as FunctionalSearch} from './SearchFunctional';
import sri from './SearchResultItem'
import CarInformation from './CarInformation';
import PartSearch from './Search/Part/PartSearch';
import BrandSearch from './Search/BrandSearch';
import ModelSearch from './Search/ModelSearch';
import TireFinder from './Tyresearch/TireFinder';


const Components = {
    search, sri, CarInformation, PartSearch, BrandSearch, ModelSearch, FunctionalSearch, TireFinder
}
export default  Components;